import { alpha, useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import React, { ReactNode } from 'react'

interface SubscriberChipProps {
	content: string | ReactNode
}

export const SubscriberChip = (props: SubscriberChipProps) => {
	const { content } = props
	const theme = useTheme()

	return (
		<Box
			component="span"
			sx={{
				border: '1px solid',
				borderColor: alpha(theme.palette.primary.main, 0.4),
				padding: '0.375rem',
				borderRadius: '4px'
			}}
		>
			{content}
		</Box>
	)
}